import { createContext, useCallback, useContext, useState } from "react";
import EventDetails from "@areas/calendar/displays/EventDetails";

const TaskDrawerContext = createContext(null);

export const useTaskDrawer = () =>
  useContext(TaskDrawerContext) ?? { openTask: () => {} };

// Mounts the calendar item (task) detail once, app-wide, so a task-assigned notification opens the
// task over the current page instead of navigating to the calendar. EventDetails fetches its own
// detail from the item's id, so a minimal { uid } is enough; read-only + elevated matches how the
// Smart Note activity feed opens it.
export function TaskDrawerProvider({ children }) {
  const [taskId, setTaskId] = useState(null);
  const openTask = useCallback((id) => setTaskId(id), []);

  return (
    <TaskDrawerContext.Provider value={{ openTask }}>
      {children}
      <EventDetails
        item={taskId ? { uid: taskId } : null}
        isOpen={!!taskId}
        onClose={() => setTaskId(null)}
        readOnly
        elevated
      />
    </TaskDrawerContext.Provider>
  );
}
